import Dexie from 'dexie'

let Db = new Dexie("Blackfon.Web")

Db.version(1).stores({

	// FUNCTIONALS 

	// GENERAL CONFIG (TOKEN HOLDER)
	configs: 'key,value'
})


export default Db